module.exports = __webpack_public_path__ + "static/media/instagram-icon.c7fb0170.svg";